export const environment = {
  production: true,
  url: "cpa.org.sa:444"
};
